import { render, staticRenderFns } from "./OrderCreatorServiceSingleSample.vue?vue&type=template&id=4bbebadc&"
import script from "./OrderCreatorServiceSingleSample.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorServiceSingleSample.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreatorServiceSingleSample.vue?vue&type=style&index=0&id=4bbebadc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports